var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutPickupTopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    viewBox: "0 0 245 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4:276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245 82.2848L211.082 81.4679L183.772 4.13877L156.776 11.0331L181.772 80.7382L64.4016 77.8847L83.3764 6.86162L56.4358 -0.0108643L35.8523 77.1985L0.7065 76.3381L0.043457 104.198L19.4423 104.667L17.2688 105.135L42.6554 221.989H200.964L228.459 109.742L244.359 110.134L245 82.2848ZM166.753 16.3372L178.903 13.2332L202.931 81.2719L189.89 80.956L166.753 16.3372ZM61.7934 9.24685L73.976 12.3509L56.5225 77.6995L43.6228 77.3836L61.7934 9.24685ZM194.965 214.376H48.7523L24.9411 104.808L220.635 109.568L194.965 214.376ZM236.904 102.336L7.77046 96.7704L8.07479 84.1581L237.197 89.7236L236.904 102.336Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3124 114.688L56.7109 114.988L60.2497 205.252L67.8511 204.952L64.3124 114.688Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1216 115.734L80.5352 116.299L87.1433 205.417L94.7298 204.852L88.1216 115.734Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.756 115.843L107.182 204.955L114.789 205.004L115.363 115.892L107.756 115.843Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.313 117.627L128.238 204.596L135.846 205.129L141.92 118.161L134.313 117.627Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.99 119.403L157.425 204.833L165.032 204.884L165.597 119.453L157.99 119.403Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.25 117.666L177.821 204.437L185.363 205.435L196.792 118.664L189.25 117.666Z",
    fill: "#6A6A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4:276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 245,
    height: 222,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPickupTopIcon);
export default __webpack_public_path__ + "static/media/about-pickup-top-icon.2b1dfc772dbfe3a0b44b7d677804dc25.svg";
export { ForwardRef as ReactComponent };